import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import GuruDashboard from './pages/GuruDashboard';
import EmeraldDashboard from './pages/EmeraldDashboard';
import AccessDenied from './pages/AccessDenied';

// Admin components
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import ManageTrades from './pages/admin/ManageTrades';
import ProductSettings from './pages/admin/ProductSettings';

import './App.css';

/**
 * Protected Routes - Require Authentication
 * NOTE: Authentication is bypassed in development mode (NODE_ENV=development)
 */
function ProtectedApp() {
  const { isAuthenticated, loading, error } = useAuth();

  // Show loading while validating token
  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Validating authentication...</p>
      </div>
    );
  }

  // Show Access Denied if not authenticated (bypassed in development)
  if (!isAuthenticated) {
    return <AccessDenied error={error} />;
  }

  // User is authenticated - show app
  return (
    <Routes>
      {/* Main page - Direct to Graham Lindman Dashboard */}
      <Route path="/" element={<Layout><GuruDashboard /></Layout>} />
      <Route path="/gurus/:slug" element={<Layout><GuruDashboard /></Layout>} />
      <Route path="/emerald" element={<Layout><EmeraldDashboard /></Layout>} />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<ManageTrades />} />
        <Route path="trades" element={<ManageTrades />} />
        <Route path="trades/:productId" element={<ManageTrades />} />
        <Route path="product-settings" element={<ProductSettings />} />
        <Route path="product-settings/:productId" element={<ProductSettings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <ProtectedApp />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
